import { render } from "./Footer.vue?vue&type=template&id=5f72e32b"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=5f72e32b&lang=scss"

import exportComponent from "C:\\Users\\Alexander\\Documents\\Hompage TT Tools\\TT Homapge Files\\Webseite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__